import { jsx as i, jsxs as N, Fragment as Ge } from "react/jsx-runtime";
import { createContext as De, useMemo as me, useContext as Le, useReducer as Ke, useRef as ne, useEffect as ee, useState as H, useCallback as Ae } from "react";
import { createPortal as Xe } from "react-dom";
import { z as a } from "zod";
import Qe from "diff-match-patch";
import { useQueryClient as ge, useMutation as he, useQuery as Ye } from "@tanstack/react-query";
import { IconQuestionLine as pe, IconPinLine as Ne, IconWarningLine as Ve, IconArrowOpenDownLine as Ze, IconEditLine as de, IconTrashLine as se, IconArrowOpenStartLine as Je, IconArrowOpenEndLine as et, IconArrowStartLine as tt } from "@instructure/ui-icons";
import { Menu as Z } from "@instructure/ui-menu";
import { Flex as v } from "@instructure/ui-flex";
import { TruncateText as ue } from "@instructure/ui-truncate-text";
import { CloseButton as nt, Button as W, IconButton as G } from "@instructure/ui-buttons";
import { Heading as ie } from "@instructure/ui-heading";
import { Tray as ot } from "@instructure/ui-tray";
import { View as K } from "@instructure/ui-view";
import { ScreenReaderContent as rt } from "@instructure/ui-a11y-content";
import { Text as U } from "@instructure/ui-text";
import { TextArea as Pe } from "@instructure/ui-text-area";
import { Pill as Ie } from "@instructure/ui-pill";
import { Spinner as st } from "@instructure/ui-spinner";
const it = a.object({
  startContainer: a.string(),
  endContainer: a.string(),
  startOffset: a.number(),
  endOffset: a.number()
}), lt = a.object({
  start: a.number(),
  end: a.number()
}), be = a.object({
  selectedText: a.string(),
  hasNoHighlightAnymore: a.boolean().optional(),
  textPosition: lt.nullable(),
  range: it.nullable(),
  pageLastModifiedAt: a.string()
});
var L = /* @__PURE__ */ ((n) => (n.IMPORTANT = "Important", n.CONFUSING = "Confusing", n))(L || {});
const ye = a.enum([
  "Important",
  "Confusing"
  /* CONFUSING */
]), Me = a.object({
  startCursor: a.string().nullish(),
  endCursor: a.string().nullish(),
  hasNextPage: a.boolean().nullish(),
  hasPreviousPage: a.boolean().nullish()
}), le = a.object({
  id: a.string(),
  rootAccountUuid: a.string(),
  userId: a.string(),
  courseId: a.string(),
  objectId: a.string(),
  objectType: a.string(),
  userText: a.string().optional(),
  reaction: a.array(ye),
  highlightData: be,
  createdAt: a.string(),
  updatedAt: a.string()
}), at = a.object({
  cursor: a.string(),
  node: le
});
a.object({
  notes: a.object({
    edges: a.array(at),
    nodes: a.array(le),
    pageInfo: Me
  })
});
const ct = a.object({
  type: a.string(),
  id: a.string()
}), dt = a.object({
  courseId: a.string().optional(),
  learningObject: ct.optional(),
  reactions: a.array(a.string()).optional()
}).optional();
a.object({
  courseId: a.string().optional(),
  filter: dt,
  pageParams: Me.optional(),
  direction: a.enum(["next", "prev"]).optional(),
  pageSize: a.number().optional()
});
a.object({
  courseId: a.string(),
  objectId: a.string(),
  objectType: a.string(),
  userText: a.string().optional(),
  reaction: a.array(ye),
  highlightData: be
});
a.object({
  createNote: le
});
a.object({
  id: a.string(),
  userText: a.string().optional(),
  reaction: a.array(ye),
  highlightData: be
});
a.object({
  updateNote: le
});
a.object({
  deleteNote: a.string()
});
var Fe = /* @__PURE__ */ ((n) => (n[n.FORWARDS = 1] = "FORWARDS", n[n.BACKWARDS = 2] = "BACKWARDS", n))(Fe || {});
class q {
  constructor(e, t) {
    this.start = e, this.end = t;
  }
  toRange() {
    let e, t;
    if (this.start.element === this.end.element && this.start.offset <= this.end.offset ? [e, t] = He(this.start.element, this.start.offset, this.end.offset) : (e = this.start.resolve({
      direction: 1
      /* FORWARDS */
    }), t = this.end.resolve({
      direction: 2
      /* BACKWARDS */
    })), !e || !t)
      return null;
    const o = new Range();
    return o.setStart(e.node, e.offset), o.setEnd(t.node, t.offset), o;
  }
  static fromRange(e) {
    const t = z.fromPoint(e.startContainer, e.startOffset), o = z.fromPoint(e.endContainer, e.endOffset);
    return !t || !o ? null : new q(t, o);
  }
  static fromOffsets(e, t, o) {
    return new q(new z(e, t), new z(e, o));
  }
  relativeTo(e) {
    return new q(this.start.relativeTo(e), this.end.relativeTo(e));
  }
}
class z {
  constructor(e, t) {
    t < 0 && console.error("Offset is invalid"), this.element = e, this.offset = t;
  }
  resolve(e = {}) {
    try {
      return He(this.element, this.offset)[0];
    } catch (t) {
      if (this.offset === 0 && e.direction !== void 0) {
        const o = document.createTreeWalker(this.element.getRootNode(), NodeFilter.SHOW_TEXT);
        o.currentNode = this.element;
        const r = e.direction === Fe.FORWARDS, s = r ? o.nextNode() : o.previousNode();
        if (!s)
          throw t;
        return { node: s, offset: r ? 0 : s.data.length };
      }
      throw t;
    }
  }
  static fromCharOffset(e, t) {
    switch (e.nodeType) {
      case Node.TEXT_NODE:
        return z.fromPoint(e, t);
      case Node.ELEMENT_NODE:
        return new z(e, t);
      default:
        return console.error("Node is not an element or text node"), null;
    }
  }
  static fromPoint(e, t) {
    switch (e.nodeType) {
      case Node.TEXT_NODE: {
        if (t < 0 || t > e.data.length)
          return console.error("Text node offset is out of range"), null;
        if (!e.parentElement)
          return console.error("Text node has no parent"), null;
        const o = ke(e) + t;
        return new z(e.parentElement, o);
      }
      case Node.ELEMENT_NODE: {
        if (t < 0 || t > e.childNodes.length)
          return console.error("Child node offset is out of range"), null;
        let o = 0;
        for (let r = 0; r < t; r++)
          o += Be(e.childNodes[r]);
        return new z(e, o);
      }
      default:
        return console.error("Point is not in an element or text node"), null;
    }
  }
  relativeTo(e) {
    if (!e.contains(this.element))
      throw new Error("Parent is not an ancestor of current element");
    let t = this.element, o = this.offset;
    for (; t !== e; )
      o += ke(t), t.parentElement && (t = t.parentElement);
    return new z(t, o);
  }
}
const ut = (n) => {
  const e = n.nodeName.toLowerCase();
  return e === "#text" ? "text()" : e;
};
function ft(n) {
  let e = 0, t = n;
  for (; t; )
    t.nodeName === n.nodeName && (e += 1), t = t.previousSibling;
  return e;
}
const mt = (n) => {
  const e = ut(n), t = ft(n);
  return `${e}[${t}]`;
}, xe = (n, e) => {
  let t = "", o = n;
  for (; o !== e; ) {
    if (!o) {
      console.error("Node is not a descendant of root");
      return;
    }
    t = `${mt(o)}/${t}`, o = o.parentNode;
  }
  return t = `/${t}`, t = t.replace(/\/$/, ""), t;
}, gt = (n, e, t) => {
  const o = e.toUpperCase();
  let r = -1;
  for (let s = 0; s < n.children.length; s++) {
    const l = n.children[s];
    if (l.nodeName.toUpperCase() === o && (++r, r === t))
      return l;
  }
  return null;
}, ht = (n, e) => {
  if (!(n.match(/^(\/[A-Za-z0-9-]+(\[[0-9]+])?)+$/) !== null))
    return console.error("Expression is not a simple XPath"), null;
  const o = n.split("/");
  let r = e;
  o.shift();
  for (const s of o) {
    let l, d;
    const f = s.indexOf("[");
    if (f !== -1) {
      l = s.slice(0, f);
      const g = s.slice(f + 1, s.indexOf("]"));
      if (d = Number.parseInt(g, 10) - 1, d < 0)
        return null;
    } else
      l = s, d = 0;
    const c = gt(r, l, d);
    if (!c)
      return null;
    r = c;
  }
  return r;
}, we = (n, e = document.body) => {
  try {
    return ht(n, e);
  } catch {
    return document.evaluate(`.${n}`, e, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
  }
};
class X {
  constructor(e, t) {
    this.root = e, this.range = t;
  }
  static fromRange(e, t) {
    return new X(e, t);
  }
  static fromSelector(e, t) {
    if (!(t != null && t.startContainer) || !(t != null && t.endContainer))
      return console.error("No start or end container in selector"), null;
    const o = we(t.startContainer, e);
    if (!o)
      return console.error("Failed to resolve startContainer XPath"), null;
    const r = we(t.endContainer, e);
    if (!r)
      return console.error("Failed to resolve endContainer XPath"), null;
    const s = z.fromCharOffset(o, t.startOffset), l = z.fromCharOffset(r, t.endOffset);
    if (!s || !l)
      return null;
    const d = new q(s, l).toRange();
    return d ? new X(e, d) : null;
  }
  toRange() {
    return this.range;
  }
  toSelector() {
    var s;
    const e = (s = q.fromRange(this.range)) == null ? void 0 : s.toRange(), t = e && q.fromRange(e), o = t && xe(t.start.element, this.root), r = t && xe(t.end.element, this.root);
    return !o || !r ? null : {
      startContainer: o,
      startOffset: t.start.offset,
      endContainer: r,
      endOffset: t.end.offset
    };
  }
}
class $ {
  constructor(e, t, o) {
    this.root = e, this.start = t, this.end = o;
  }
  static fromRange(e, t) {
    var r;
    const o = (r = q.fromRange(t)) == null ? void 0 : r.relativeTo(e);
    return o ? new $(e, o.start.offset, o.end.offset) : null;
  }
  static fromSelector(e, t) {
    return new $(e, t.start, t.end);
  }
  toSelector() {
    return {
      start: this.start,
      end: this.end
    };
  }
  toRange() {
    return q.fromOffsets(this.root, this.start, this.end).toRange();
  }
}
const Be = (n) => {
  var e;
  switch (n.nodeType) {
    case Node.ELEMENT_NODE:
    case Node.TEXT_NODE:
      return ((e = n.textContent) == null ? void 0 : e.length) ?? 0;
    default:
      return 0;
  }
}, ke = (n) => {
  let e = n.previousSibling, t = 0;
  for (; e; )
    t += Be(e), e = e.previousSibling;
  return t;
}, He = (n, ...e) => {
  let t = e.shift();
  const o = n.ownerDocument.createNodeIterator(n, NodeFilter.SHOW_TEXT), r = [];
  let s = o.nextNode(), l = null, d = 0;
  for (; t !== void 0 && s; )
    l = s, d + l.data.length > t ? (r.push({ node: l, offset: t - d }), t = e.shift()) : (s = o.nextNode(), d += l.data.length);
  for (; t !== void 0 && l && d === t; )
    r.push({ node: l, offset: l.data.length }), t = e.shift();
  return t !== void 0 && console.error("Offset exceeds text length"), r;
}, pt = (n, e, t, o) => {
  const r = t - e;
  return Math.abs(r - o) <= 5 ? $.fromSelector(n, {
    start: e,
    end: t
  }) : null;
}, Nt = (n, e, t, o) => {
  const r = new Qe();
  r.Match_Distance = 5e3;
  const s = n.textContent;
  if (!s)
    return null;
  if (e.length > 32) {
    const l = e.slice(0, 32), d = e.slice(-32), f = o - t;
    let c = r.match_main(s, l, t);
    const g = r.match_main(s, d, o), m = g + d.length;
    if (c === -1 || g === -1)
      return null;
    const u = m - c, S = Math.abs(u - f);
    if ((c > m || S > 5) && (r.Match_Distance = e.length + 100, c = r.match_main(s, l, m), c !== -1 && c < m))
      return pt(n, c, m, f);
    if (c < m && S <= 5)
      return $.fromSelector(n, {
        start: c,
        end: m
      });
  } else {
    const l = r.match_main(s, e, t);
    if (l !== -1)
      return $.fromSelector(n, {
        start: l,
        end: l + e.length
      });
  }
  return null;
}, bt = (n, e) => {
  if (!e) return null;
  const { highlightData: t } = n, { textPosition: o, selectedText: r } = t;
  return Nt(
    e,
    r,
    (o == null ? void 0 : o.start) ?? 0,
    (o == null ? void 0 : o.end) ?? 0
  );
}, yt = (n, e, t) => {
  const o = [], r = [];
  for (const s of e) {
    const l = bt(s, n);
    if (l) {
      const d = l.toRange(), f = d && X.fromRange(n, d);
      o.push({
        id: s.id,
        reaction: s.reaction,
        userText: s.userText,
        highlightData: {
          ...s.highlightData,
          hasNoHighlightAnymore: !1,
          range: (f == null ? void 0 : f.toSelector()) ?? null,
          textPosition: l.toSelector(),
          pageLastModifiedAt: t
        }
      });
    } else
      s.userText ? o.push({
        id: s.id,
        reaction: s.reaction,
        userText: s.userText,
        highlightData: {
          ...s.highlightData,
          pageLastModifiedAt: t,
          hasNoHighlightAnymore: !0
        }
      }) : r.push(s.id);
  }
  return { notesForUpdate: o, noteIdsForDelete: r };
}, Oe = (n, e) => {
  var l;
  if (!e) return;
  const { highlightData: t, id: o } = n, { range: r } = t ?? {};
  r && ((l = X.fromSelector(e, r)) == null ? void 0 : l.toRange()) && wt({ id: o });
}, St = (n) => {
  const e = document.getElementById(Ce(n));
  if (e) {
    const t = e.getBoundingClientRect();
    t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth) || e.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}, oe = 90, re = 172, Ct = (n) => {
  const e = n.getClientRects();
  if (!e.length)
    return null;
  const t = e[0], o = e[e.length - 1], r = 4, s = 16, l = window.innerWidth || document.documentElement.clientWidth, d = window.innerHeight || document.documentElement.clientHeight, f = (C) => {
    const I = C + re;
    return C >= s && I <= l - s;
  }, c = (C) => {
    const I = C + oe;
    return C >= s && I <= d - s;
  };
  let g;
  const m = t.right - re;
  if (f(m))
    g = m;
  else {
    const C = t.left;
    if (f(C))
      g = C;
    else {
      const O = (t.left + t.right) / 2 - re / 2;
      f(O) ? g = O : m < s ? g = s : g = l - re - s;
    }
  }
  let u;
  const S = o.bottom + r;
  if (c(S))
    u = S;
  else {
    const C = t.top - oe - r;
    c(C) ? u = C : S + oe > d - s ? u = d - oe - s : u = s;
  }
  return { top: u, left: g };
}, vt = (n, e) => {
  for (const t of e)
    if (n.start < t.end && n.end > t.start)
      return !0;
  return !1;
}, Se = (n) => `highlight-wrapper-${n}`, Ce = (n) => `${Se(n)}-start`, ze = (n) => `${Se(n)}-end`, te = (n) => `[data-highlight-id="${CSS.escape(n)}"]`, ae = (n, e) => {
  const t = Number.parseInt(n.slice(1, 3), 16), o = Number.parseInt(n.slice(3, 5), 16), r = Number.parseInt(n.slice(5, 7), 16);
  return `rgba(${t}, ${o}, ${r}, ${e})`;
}, Et = (n, e) => {
  var t;
  try {
    const o = ((t = e.nodeValue) == null ? void 0 : t.length) ?? e.childNodes.length;
    return n.comparePoint(e, 0) <= 0 && n.comparePoint(e, o) >= 0;
  } catch {
    return !1;
  }
}, Tt = (n) => {
  var s;
  if (n.collapsed)
    return [];
  let e = n.commonAncestorContainer;
  if (e && e.nodeType !== Node.ELEMENT_NODE && (e = e.parentElement), !e)
    return [];
  const t = [], o = (s = e == null ? void 0 : e.ownerDocument) == null ? void 0 : s.createNodeIterator(e, NodeFilter.SHOW_TEXT);
  let r = (o == null ? void 0 : o.nextNode()) || null;
  for (; r; ) {
    if (!Et(n, r)) {
      r = (o == null ? void 0 : o.nextNode()) || null;
      continue;
    }
    const l = r;
    if (l === n.startContainer && n.startOffset > 0) {
      l.splitText(n.startOffset), r = (o == null ? void 0 : o.nextNode()) || null;
      continue;
    }
    l === n.endContainer && n.endOffset < l.data.length && l.splitText(n.endOffset), t.push(l), r = (o == null ? void 0 : o.nextNode()) || null;
  }
  return t;
}, It = (n, e, t) => {
  if (n.collapsed) return;
  const o = e.id ?? "", r = Se(o);
  if (document.getElementById(Ce(o))) {
    xt(e, t);
    return;
  }
  const l = e.type === L.IMPORTANT ? t.colors.importantBackground : t.colors.confusingBackground, f = e.id === e.selectedNoteId ? l : ae(l, 0.5), c = e.type === L.IMPORTANT ? t.colors.importantUnderline : t.colors.confusingUnderline, g = e.type === L.IMPORTANT ? "solid" : "dashed", m = n.toString(), u = document.createElement("span");
  u.id = `${r}-start`, u.className = "highlight-marker-start", u.dataset.highlightId = o || "", u.setAttribute("role", "button"), u.setAttribute("tabindex", "0"), u.setAttribute("aria-label", m), u.style.position = "relative", u.style.fontSize = "0", u.style.lineHeight = "0", u.style.width = "0", u.style.height = "0", u.style.margin = "0", u.style.padding = "0", u.style.border = "0";
  const S = document.createElement("span");
  S.id = ze(o), S.className = "highlight-marker-end", S.dataset.highlightId = o || "";
  const C = n.cloneRange();
  C.collapse(!1), C.insertNode(S);
  const I = n.cloneRange();
  I.collapse(!0), I.insertNode(u);
  const O = document.createRange();
  O.setStartAfter(u), O.setEndBefore(S);
  const w = Tt(O).filter((b) => b.textContent && b.textContent.length > 0);
  w.forEach((b, k) => {
    var Y;
    const D = b.parentElement;
    if ((D == null ? void 0 : D.dataset.highlightId) === o) return;
    const B = k === 0, E = k === w.length - 1, j = w.length === 1;
    let A;
    j ? A = "single" : B ? A = "first" : E ? A = "last" : A = "middle";
    const x = document.createElement("span");
    x.className = "highlight-content", x.dataset.highlightId = o || "", x.dataset.position = A, x.style.backgroundColor = f, x.style.textDecorationLine = "underline", x.style.textDecorationColor = c, x.style.textDecorationStyle = g, x.style.textDecorationThickness = t.borderWidthSmall, x.style.textUnderlineOffset = t.underlineOffset, x.style.cursor = "pointer", x.addEventListener("click", (T) => {
      var p;
      T.target.tagName !== "A" && ((p = e.onClick) == null || p.call(e));
    }), (Y = b.parentNode) == null || Y.insertBefore(x, b), x.appendChild(b);
  }), u.addEventListener("click", (b) => {
    var k;
    b.target.tagName !== "A" && ((k = e.onClick) == null || k.call(e));
  }), u.addEventListener("keydown", (b) => {
    var k;
    if (b.key === "Enter" || b.key === " ")
      b.preventDefault(), (k = e.onClick) == null || k.call(e);
    else if (b.key === "Tab" && !b.shiftKey) {
      const D = document.querySelectorAll(te(o));
      for (const B of D) {
        const E = B.querySelector("a");
        if (E) {
          b.preventDefault(), E.focus();
          break;
        }
      }
    }
  }), u.addEventListener("focus", () => {
    document.querySelectorAll(
      te(o)
    ).forEach((k) => {
      k.classList.add("highlight-focused");
    });
  }), u.addEventListener("blur", () => {
    document.querySelectorAll(
      te(o)
    ).forEach((k) => {
      k.classList.remove("highlight-focused");
    });
  });
};
function xt(n, e) {
  const t = n.type === L.IMPORTANT ? e.colors.importantBackground : e.colors.confusingBackground, r = n.id === n.selectedNoteId ? t : ae(t, 0.5);
  document.querySelectorAll(
    te(n.id ?? "")
  ).forEach((l) => {
    l.style.backgroundColor = r;
  });
}
const wt = (n) => {
  const e = n.id ?? "", t = document.getElementById(Ce(e)), o = document.getElementById(ze(e));
  document.querySelectorAll(
    te(e)
  ).forEach((s) => {
    var l;
    for (; s.firstChild; )
      (l = s.parentNode) == null || l.insertBefore(s.firstChild, s);
    s.remove();
  }), t == null || t.remove(), o == null || o.remove();
}, J = {
  all: ["notebook"],
  notes: (n) => ["notebook", "notes", n]
};
function kt(n) {
  const e = ge();
  return he({
    mutationFn: (t) => n.createNote(t),
    onSuccess: () => {
      e.invalidateQueries({ queryKey: J.all });
    }
  });
}
function Ot(n) {
  const e = ge();
  return he({
    mutationFn: (t) => n.deleteNote(t),
    onSuccess: () => {
      e.invalidateQueries({ queryKey: J.all });
    }
  });
}
function Rt({
  api: n,
  enabled: e = !0,
  ...t
}) {
  return Ye({
    queryKey: J.notes(t),
    queryFn: () => n.getNotes(t),
    enabled: e
  });
}
function Dt(n) {
  const e = ge();
  return he({
    mutationFn: ({ id: t, input: o }) => n.updateNote(t, o),
    onMutate: async ({ id: t, input: o }) => {
      await e.cancelQueries({ queryKey: J.all });
      const s = e.getQueryCache().findAll({ queryKey: J.all }), l = /* @__PURE__ */ new Map();
      for (const d of s) {
        const f = d.state.data;
        f && (l.set(d.queryKey, f), e.setQueryData(d.queryKey, {
          ...f,
          notes: f.notes.map(
            (c) => c.id === t ? { ...c, ...o, updatedAt: (/* @__PURE__ */ new Date()).toISOString() } : c
          )
        }));
      }
      return { previousData: l };
    },
    onError: (t, o, r) => {
      if (r != null && r.previousData)
        for (const [s, l] of r.previousData)
          e.setQueryData(s, l);
    },
    onSettled: () => {
      e.invalidateQueries({ queryKey: J.all });
    }
  });
}
const Lt = "Notebook", At = "Notes", Pt = "Important", Mt = "Unclear", Ft = "Back", Bt = "Edit note", Ht = "Save", zt = "Cancel", jt = "Delete note", _t = "note", Ut = "Add note (optional)", Wt = "Remove from Notebook", qt = "Add a note (optional).", $t = "Mark important", Gt = "Mark unclear", Kt = "Saved to Notebook.", Xt = "Note updated", Qt = "Note deleted", Yt = "Error saving to Notebook.", Vt = "Error updating note", Zt = "Note deletion failed", Jt = "Loading notes", en = "Failed to load notes", tn = "Start capturing your notes", nn = "Your notes from learning materials will appear here. Highlight key ideas, reflections, or questions as you learn—they'll all be saved in your Notebook for easy review later.", on = "Nothing here yet", rn = "Adjust your filters or create a new note to get started.", sn = "You have no notes for the selected filter", ln = "Previous page", an = "Next page", cn = "All courses", dn = "All notes", un = "Close Notebook panel", fn = "To use the Notebook feature, highlight an excerpt from your learning material to flag it as 'confusing' or 'important' and leave an optional note.", mn = "The content you highlighted is no longer available.", ve = {
  notebook: Lt,
  notes: At,
  important: Pt,
  unclear: Mt,
  back: Ft,
  editNote: Bt,
  save: Ht,
  cancel: zt,
  deleteNote: jt,
  note: _t,
  addNotePrompt: Ut,
  removeFromNotebook: Wt,
  addNoteOptional: qt,
  markImportant: $t,
  markUnclear: Gt,
  savedToNotebook: Kt,
  noteUpdated: Xt,
  noteDeleted: Qt,
  errorSavingNote: Yt,
  errorUpdatingNote: Vt,
  noteDeletionFailed: Zt,
  loadingNotes: Jt,
  failedToLoadNotes: en,
  emptyStateHeading: tn,
  emptyStateDescription: nn,
  nothingHereYet: on,
  adjustFiltersOrCreate: rn,
  noNotesForFilter: sn,
  previousPage: ln,
  nextPage: an,
  allCourses: cn,
  allNotes: dn,
  closeNotebookPanel: un,
  featureDescription: fn,
  highlightUnavailable: mn
}, je = De(null);
function _e(n, e) {
  const t = ve[n] ?? n;
  return e ? t.replace(/%\{([^}]+)}/g, (o, r) => String(e[r] ?? `%{${r}}`)) : t;
}
function gn({
  translations: n,
  translate: e,
  children: t
}) {
  const o = me(
    () => ({
      translations: { ...ve, ...n },
      translate: e ?? _e
    }),
    [n, e]
  );
  return /* @__PURE__ */ i(je.Provider, { value: o, children: t });
}
function Q() {
  const n = Le(je);
  return n || { translations: ve, translate: _e };
}
const hn = {
  selectedNoteId: null,
  isNoteEditing: !1,
  isTrayOpen: !1
};
function pn(n, e) {
  switch (e.type) {
    case "SELECT_NOTE":
      return {
        ...n,
        selectedNoteId: e.payload.id,
        isNoteEditing: e.payload.isEditing
      };
    case "CLEAR_SELECTED_NOTE":
      return { ...n, selectedNoteId: null, isNoteEditing: !1 };
    case "SET_EDITING":
      return { ...n, isNoteEditing: e.payload };
    case "OPEN_TRAY":
      return { ...n, isTrayOpen: !0 };
    case "CLOSE_TRAY":
      return { ...n, isTrayOpen: !1, selectedNoteId: null, isNoteEditing: !1 };
    default:
      return n;
  }
}
const Ue = De(null);
function Wn({
  api: n,
  currentUserId: e,
  objectId: t,
  objectType: o,
  courseId: r,
  pageLastModifiedAt: s,
  onAnalyticsEvent: l,
  translations: d,
  translate: f,
  children: c
}) {
  const [g, m] = Ke(pn, hn), u = me(
    () => ({
      api: n,
      currentUserId: e,
      objectId: t,
      objectType: o,
      courseId: r,
      pageLastModifiedAt: s,
      onAnalyticsEvent: l,
      ...g,
      selectNote: (S, C = !1) => m({ type: "SELECT_NOTE", payload: { id: S, isEditing: C } }),
      clearSelectedNote: () => m({ type: "CLEAR_SELECTED_NOTE" }),
      setEditing: (S) => m({ type: "SET_EDITING", payload: S }),
      openTray: () => m({ type: "OPEN_TRAY" }),
      closeTray: () => m({ type: "CLOSE_TRAY" })
    }),
    [
      n,
      e,
      t,
      o,
      r,
      s,
      l,
      g
    ]
  );
  return /* @__PURE__ */ i(Ue.Provider, { value: u, children: /* @__PURE__ */ i(gn, { translations: d, translate: f, children: c }) });
}
function We() {
  const n = Le(Ue);
  if (!n)
    throw new Error("useNotebook must be used within a NotebookProvider");
  return n;
}
const Nn = ({ currentType: n, onSelectReaction: e }) => {
  const { translations: t } = Q(), o = ne(null), r = ne(null);
  return ee(() => {
    n === L.CONFUSING && o.current ? o.current.focus() : n === L.IMPORTANT && r.current ? r.current.focus() : o.current && o.current.focus();
  }, [n]), /* @__PURE__ */ N(Z, { children: [
    /* @__PURE__ */ N(Z.Item, { ref: o, onClick: () => e(L.CONFUSING), children: [
      /* @__PURE__ */ i(pe, { size: "x-small" }),
      ` ${t.markUnclear}`
    ] }),
    /* @__PURE__ */ N(Z.Item, { ref: r, onClick: () => e(L.IMPORTANT), children: [
      /* @__PURE__ */ i(Ne, { size: "x-small" }),
      ` ${t.markImportant}`
    ] })
  ] });
}, ce = "notebook-inline-reaction-menu";
function qn({
  containerRef: n,
  highlightTheme: e,
  debounceTime: t = 500
}) {
  const {
    api: o,
    objectId: r,
    objectType: s,
    courseId: l,
    pageLastModifiedAt: d,
    selectedNoteId: f,
    selectNote: c,
    openTray: g
  } = We(), { data: m } = Rt({
    api: o,
    filter: {
      learningObject: { type: s, id: r }
    },
    courseId: l,
    pageSize: 100
  }), { mutate: u } = kt(o), { mutate: S } = Dt(o), { mutate: C } = Ot(o), I = ne([]), [O, R] = H([]), [w, b] = H(null), [k, D] = H(""), [B, E] = H(null), [j, A] = H(!1);
  ee(() => {
    const T = n.current;
    if (!T) return;
    const p = T.closest(".user_content") ?? T;
    if (p.classList.contains("enhanced")) {
      A(!0);
      return;
    }
    const P = new MutationObserver((M) => {
      for (const F of M)
        if (F.type === "attributes" && F.attributeName === "class" && F.target.classList.contains("enhanced")) {
          A(!0), P.disconnect();
          return;
        }
    });
    return P.observe(p, { attributes: !0, attributeFilter: ["class"] }), () => P.disconnect();
  }, [n]), ee(() => {
    if (!j || !n.current) return;
    let p = null;
    const P = () => {
      p && clearTimeout(p), p = setTimeout(() => {
        var Te;
        const y = window.getSelection(), h = n.current;
        if (!(y != null && y.rangeCount) || !h) return;
        const _ = y.toString().trim();
        if (_ === "") return;
        const V = y.getRangeAt(0);
        if (!h.contains(V.commonAncestorContainer)) return;
        const Ee = (Te = $.fromRange(h, V)) == null ? void 0 : Te.toSelector();
        Ee && !vt(Ee, O) && (b(V.cloneRange()), D(_), E(Ct(V)));
      }, t);
    }, M = (y) => {
      if (!(y.target instanceof Node)) return;
      const h = document.getElementById(ce);
      h != null && h.contains(y.target) ? (y.preventDefault(), y.stopImmediatePropagation()) : (E(null), b(null), D(""));
    }, F = () => {
      E(null), b(null), D("");
    };
    return document.addEventListener("selectionchange", P), document.addEventListener("mousedown", M), document.addEventListener("touchstart", M), window.addEventListener("scroll", F, !0), () => {
      p && clearTimeout(p), document.removeEventListener("selectionchange", P), document.removeEventListener("mousedown", M), document.removeEventListener("touchstart", M), window.removeEventListener("scroll", F, !0);
    };
  }, [j, O, t, n]), ee(() => {
    f && St(f);
  }, [f]);
  const x = Ae(
    (T) => {
      var _;
      const p = n.current;
      if (!p || !T.highlightData) return null;
      const { highlightData: P, reaction: M, id: F } = T, { range: y } = P, h = y && ((_ = X.fromSelector(p, y)) == null ? void 0 : _.toRange());
      if (h) {
        const V = {
          id: F,
          selectedNoteId: f,
          type: M[0],
          onClick: () => {
            c(F), g();
          }
        };
        return It(h, V, e), P.textPosition;
      }
      return null;
    },
    [n, f, e, c, g]
  );
  ee(() => {
    if (!j || !m || !n.current) return;
    const T = n.current, p = m.notes, P = /* @__PURE__ */ new Set(), M = [], F = [];
    if (p.length === 0) {
      if (I.current.length > 0) {
        for (const y of I.current)
          Oe(y, T);
        I.current = [], R([]);
      }
      return;
    }
    if (d && p[0].highlightData.pageLastModifiedAt !== d) {
      const { notesForUpdate: y, noteIdsForDelete: h } = yt(
        T,
        p,
        d
      );
      for (const _ of y)
        S({ id: _.id, input: _ });
      for (const _ of h)
        C(_);
    } else {
      for (const y of p) {
        const h = x(y);
        P.add(y.id), h && (M.push(y), F.push(h));
      }
      for (const y of I.current)
        P.has(y.id) || Oe(y, T);
      R(F), I.current = M;
    }
  }, [
    j,
    m,
    x,
    d,
    n,
    S,
    C
  ]);
  const Y = (T) => {
    const p = n.current;
    if (!w || !p) return;
    const P = X.fromRange(p, w), M = $.fromRange(p, w);
    u(
      {
        courseId: l,
        objectId: r,
        objectType: s,
        userText: "",
        reaction: [T],
        highlightData: {
          selectedText: k,
          textPosition: (M == null ? void 0 : M.toSelector()) ?? null,
          range: P.toSelector(),
          pageLastModifiedAt: d ?? ""
        }
      },
      {
        onSuccess: (F) => {
          var h;
          const y = F.id;
          b(null), D(""), E(null), (h = window.getSelection()) == null || h.removeAllRanges(), c(y), g();
        }
      }
    );
  };
  return !w || !B ? null : Xe(
    /* @__PURE__ */ i(
      "div",
      {
        id: ce,
        role: "toolbar",
        style: {
          position: "fixed",
          zIndex: 100,
          top: B.top,
          left: B.left,
          whiteSpace: "nowrap"
        },
        onBlur: (T) => {
          const p = document.getElementById(ce);
          p != null && p.contains(T.relatedTarget) || (E(null), b(null), D(""));
        },
        children: /* @__PURE__ */ i(Nn, { onSelectReaction: Y })
      }
    ),
    document.body
  );
}
const bn = (n, e) => ({
  backgroundColor: n === L.IMPORTANT ? e.colors.importantBackground : e.colors.confusingBackground,
  underlineColor: n === L.IMPORTANT ? e.colors.importantUnderline : e.colors.confusingUnderline,
  underlineStyle: n === L.IMPORTANT ? "solid" : "dashed"
}), fe = ({
  children: n,
  type: e = L.IMPORTANT,
  isCardActive: t = !0,
  theme: o
}) => {
  const r = bn(e, o), l = {
    position: "relative",
    backgroundColor: t ? r.backgroundColor : ae(r.backgroundColor, 0.5),
    textDecorationLine: "underline",
    textDecorationStyle: r.underlineStyle,
    textDecorationColor: r.underlineColor,
    textDecorationThickness: o.borderWidthSmall,
    textUnderlineOffset: o.underlineOffset,
    lineHeight: "normal"
  };
  return /* @__PURE__ */ i("span", { "data-note-highlight": "true", style: l, children: n });
}, qe = () => {
  const { translations: n } = Q();
  return /* @__PURE__ */ N(v, { gap: "xx-small", alignItems: "start", as: "div", children: [
    /* @__PURE__ */ i(v.Item, { as: "div", children: /* @__PURE__ */ i(Ve, { color: "error" }) }),
    /* @__PURE__ */ i(v.Item, { padding: "xxx-small none", shouldShrink: !0, children: /* @__PURE__ */ i(ue, { maxLines: 3, children: n.highlightUnavailable }) })
  ] });
}, $n = ({ children: n }) => {
  const { isTrayOpen: e, closeTray: t } = We(), { translations: o } = Q();
  return /* @__PURE__ */ i(
    ot,
    {
      label: o.notebook,
      open: e,
      onDismiss: t,
      placement: "end",
      size: "regular",
      children: /* @__PURE__ */ N(v, { direction: "column", height: "100vh", children: [
        /* @__PURE__ */ i(v.Item, { children: /* @__PURE__ */ i(K, { as: "div", padding: "small medium", borderWidth: "0 0 small 0", children: /* @__PURE__ */ N(v, { justifyItems: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ i(ie, { level: "h3", children: o.notebook }),
          /* @__PURE__ */ i(
            nt,
            {
              screenReaderLabel: o.closeNotebookPanel,
              onClick: t,
              size: "small",
              "data-testid": "notebook-tray-close"
            }
          )
        ] }) }) }),
        /* @__PURE__ */ i(v.Item, { shouldGrow: !0, shouldShrink: !0, overflowY: "auto", overflowX: "hidden", children: n })
      ] })
    }
  );
}, yn = {
  [L.IMPORTANT]: {
    color: "info",
    translationKey: "important",
    icon: /* @__PURE__ */ i(Ne, { size: "x-small" })
  },
  [L.CONFUSING]: {
    color: "danger",
    translationKey: "unclear",
    icon: /* @__PURE__ */ i(pe, { size: "x-small" })
  }
}, $e = ({ type: n, onTypeChange: e, renderAsMenuTrigger: t = !1 }) => {
  const { translations: o } = Q(), r = yn[n], s = o[r.translationKey], [l, d] = H(!1), f = ne(null), c = ne(null), g = Ae(
    (m) => {
      e == null || e(m), d(!1);
    },
    [e]
  );
  return t && e ? /* @__PURE__ */ N(
    Z,
    {
      placement: "bottom start",
      show: l,
      onToggle: (m) => d(m),
      shouldHideOnSelect: !0,
      shouldFocusTriggerOnClose: !0,
      trigger: /* @__PURE__ */ N(Ie, { color: r.color, renderIcon: r.icon, children: [
        s,
        " ",
        /* @__PURE__ */ i(Ze, { size: "x-small" })
      ] }),
      children: [
        /* @__PURE__ */ N(Z.Item, { ref: f, onClick: () => g(L.CONFUSING), children: [
          /* @__PURE__ */ i(pe, { size: "x-small" }),
          ` ${o.markUnclear}`
        ] }),
        /* @__PURE__ */ N(Z.Item, { ref: c, onClick: () => g(L.IMPORTANT), children: [
          /* @__PURE__ */ i(Ne, { size: "x-small" }),
          ` ${o.markImportant}`
        ] })
      ]
    }
  ) : /* @__PURE__ */ i(Ie, { color: r.color, renderIcon: r.icon, children: s });
};
function Re(n, e) {
  return (n instanceof Date ? n : new Date(n)).toLocaleString(e, {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
const Sn = ({
  noteId: n,
  date: e,
  highlight: t,
  note: o,
  type: r,
  onClick: s,
  onDelete: l,
  onSaveNote: d,
  onTypeChange: f,
  isActive: c,
  isPanelView: g = !1,
  courseName: m,
  locale: u,
  highlightTheme: S,
  cardTheme: C,
  renderLink: I,
  href: O
}) => {
  const { translations: R } = Q(), [w, b] = H(!1), [k, D] = H(!1), [B, E] = H(o || ""), [j, A] = H(!1), x = r === L.IMPORTANT ? R.important : R.unclear, Y = (h) => {
    h.key === "Enter" && (h.preventDefault(), s == null || s());
  }, T = [x, R.note];
  t && T.push(t), o && T.push(o), e && T.push(Re(e, u)), m && T.push(m);
  const p = T.join(", "), P = r === L.CONFUSING ? C.confusingBorderColor : C.importantBorderColor, F = {
    borderStyle: "solid",
    borderColor: c || w ? P : ae(P, 0.5),
    borderWidth: "0.0625rem 0.0625rem 0.25rem 0.25rem",
    borderRadius: "1rem",
    padding: "1rem",
    cursor: k ? "default" : "pointer",
    position: "relative"
  }, y = (
    // biome-ignore lint/a11y/noStaticElementInteractions: role is conditionally set to "button"
    // biome-ignore lint/a11y/useAriaPropsSupportedByRole: aria-label applies when role="button"
    /* @__PURE__ */ N(
      "div",
      {
        role: O || k ? void 0 : "button",
        "aria-label": O ? void 0 : p,
        "aria-pressed": O || k ? void 0 : c,
        tabIndex: O || c ? -1 : 0,
        "data-testid": "note-card",
        onClick: c ? void 0 : s,
        onMouseEnter: () => b(!0),
        onMouseLeave: () => b(!1),
        onKeyDown: c ? void 0 : Y,
        style: F,
        children: [
          /* @__PURE__ */ N(v, { direction: "column", gap: "small", children: [
            /* @__PURE__ */ i(
              $e,
              {
                type: r,
                onTypeChange: g && f ? (h) => f(n, h) : void 0,
                renderAsMenuTrigger: g && !!f && !!c
              }
            ),
            t ? /* @__PURE__ */ i("div", { style: { wordBreak: "break-word", overflowWrap: "break-word" }, children: /* @__PURE__ */ i(U, { children: c && g ? /* @__PURE__ */ i(
              fe,
              {
                type: r,
                isCardActive: !!c || w,
                theme: S,
                children: t
              }
            ) : /* @__PURE__ */ i(ue, { maxLines: 3, truncate: "word", children: /* @__PURE__ */ i(
              fe,
              {
                type: r,
                isCardActive: !!c || w,
                theme: S,
                children: t
              }
            ) }) }) }) : /* @__PURE__ */ i(qe, {}),
            /* @__PURE__ */ N(v, { direction: "column", gap: c ? "small" : "none", children: [
              k && g ? /* @__PURE__ */ N(v, { direction: "column", gap: "x-small", children: [
                /* @__PURE__ */ i(
                  Pe,
                  {
                    label: /* @__PURE__ */ i(rt, { children: R.editNote }),
                    value: B,
                    onChange: (h) => E(h.target.value),
                    placeholder: R.addNoteOptional
                  }
                ),
                /* @__PURE__ */ N(v, { gap: "xx-small", children: [
                  /* @__PURE__ */ i(v.Item, { shouldGrow: !0, children: /* @__PURE__ */ i(
                    W,
                    {
                      display: "block",
                      size: "small",
                      "data-testid": "note-card-cancel",
                      onClick: () => {
                        E(o || ""), D(!1);
                      },
                      children: R.cancel
                    }
                  ) }),
                  /* @__PURE__ */ i(v.Item, { shouldGrow: !0, children: /* @__PURE__ */ i(
                    W,
                    {
                      display: "block",
                      color: "primary",
                      size: "small",
                      "data-testid": "note-card-save",
                      onClick: () => {
                        d == null || d(n, B), D(!1);
                      },
                      interaction: B.trim() ? "enabled" : "disabled",
                      children: R.save
                    }
                  ) })
                ] })
              ] }) : o ? /* @__PURE__ */ i("div", { style: { wordBreak: "break-word", overflowWrap: "break-word" }, children: c && g ? /* @__PURE__ */ N(U, { children: [
                o,
                " ",
                /* @__PURE__ */ i(
                  G,
                  {
                    size: "small",
                    withBackground: !1,
                    withBorder: !1,
                    screenReaderLabel: R.editNote,
                    "data-testid": "note-card-edit",
                    onClick: (h) => {
                      h.stopPropagation(), D(!0);
                    },
                    children: /* @__PURE__ */ i(de, {})
                  }
                )
              ] }) : /* @__PURE__ */ i(U, { children: /* @__PURE__ */ i(ue, { maxLines: 3, truncate: "word", children: o }) }) }) : g && c ? /* @__PURE__ */ i("div", { children: /* @__PURE__ */ N(U, { color: "secondary", children: [
                R.addNotePrompt,
                " ",
                /* @__PURE__ */ i(
                  G,
                  {
                    size: "small",
                    withBackground: !1,
                    withBorder: !1,
                    screenReaderLabel: R.editNote,
                    "data-testid": "note-card-edit",
                    onClick: (h) => {
                      h.stopPropagation(), D(!0);
                    },
                    children: /* @__PURE__ */ i(de, {})
                  }
                )
              ] }) }) : null,
              /* @__PURE__ */ N(v, { justifyItems: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ i(U, { size: "small", color: "secondary", children: Re(e, u) }),
                c && l && /* @__PURE__ */ i(
                  G,
                  {
                    size: "small",
                    withBackground: !1,
                    withBorder: !1,
                    color: "danger",
                    screenReaderLabel: R.deleteNote,
                    "data-testid": "note-card-delete",
                    onClick: (h) => {
                      h.stopPropagation(), A(!0);
                    },
                    children: /* @__PURE__ */ i(se, {})
                  }
                )
              ] }),
              m && /* @__PURE__ */ i(U, { size: "small", color: "secondary", children: m })
            ] })
          ] }),
          j && l && /* @__PURE__ */ i(
            K,
            {
              as: "div",
              background: "primary",
              padding: "medium",
              borderRadius: "large",
              position: "absolute",
              insetBlockStart: "0",
              insetBlockEnd: "0",
              insetInlineStart: "0",
              insetInlineEnd: "0",
              stacking: "above",
              children: /* @__PURE__ */ N(
                v,
                {
                  direction: "column",
                  justifyItems: "center",
                  alignItems: "center",
                  gap: "x-small",
                  height: "100%",
                  children: [
                    /* @__PURE__ */ i(
                      W,
                      {
                        display: "block",
                        color: "danger",
                        size: "small",
                        renderIcon: /* @__PURE__ */ i(se, {}),
                        "data-testid": "note-card-confirm-delete",
                        onClick: (h) => {
                          h.stopPropagation(), l(n), A(!1);
                        },
                        children: R.deleteNote
                      }
                    ),
                    /* @__PURE__ */ i(
                      W,
                      {
                        display: "block",
                        size: "small",
                        "data-testid": "note-card-cancel-delete",
                        onClick: (h) => {
                          h.stopPropagation(), A(!1);
                        },
                        children: R.cancel
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      }
    )
  );
  return O && I ? I({ href: O, children: y, ariaLabel: p }) : y;
};
function Cn(n, e) {
  const t = Array.from({ length: e }, () => []);
  return n.forEach((o, r) => {
    t[r % e].push(o);
  }), t;
}
const vn = {
  display: "flex",
  gap: "1rem",
  padding: "1rem",
  boxSizing: "border-box",
  width: "100%",
  alignItems: "flex-start"
}, En = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  flex: 1,
  minWidth: 0
}, Gn = ({
  notes: n,
  isLoading: e,
  isError: t,
  pageInfo: o,
  onPreviousPage: r,
  onNextPage: s,
  onNoteSelect: l,
  onNoteDelete: d,
  onNoteSave: f,
  onNoteTypeChange: c,
  selectedNoteId: g,
  hasActiveFilter: m = !1,
  columnCount: u = 1,
  highlightTheme: S,
  cardTheme: C,
  locale: I,
  renderNoteLink: O,
  noteHref: R
}) => {
  const { translations: w } = Q(), b = me(
    () => Cn(n, u),
    [n, u]
  ), k = (o == null ? void 0 : o.hasNextPage) || (o == null ? void 0 : o.hasPreviousPage);
  if (e)
    return /* @__PURE__ */ i(K, { as: "div", textAlign: "center", padding: "large", "data-testid": "notes-loading", children: /* @__PURE__ */ i(st, { renderTitle: w.loadingNotes }) });
  if (t)
    return /* @__PURE__ */ i(K, { as: "div", textAlign: "center", padding: "large", "data-testid": "notes-error", children: /* @__PURE__ */ i(ie, { level: "h4", children: w.failedToLoadNotes }) });
  if (n.length === 0) {
    const D = m ? w.nothingHereYet : w.emptyStateHeading, B = m ? w.adjustFiltersOrCreate : w.emptyStateDescription;
    return /* @__PURE__ */ N(
      v,
      {
        direction: "column",
        alignItems: "center",
        justifyItems: "center",
        padding: "large",
        gap: "small",
        "data-testid": "empty-notes",
        children: [
          /* @__PURE__ */ i(ie, { level: "h3", children: D }),
          /* @__PURE__ */ i(U, { color: "secondary", children: B })
        ]
      }
    );
  }
  return /* @__PURE__ */ N(Ge, { children: [
    /* @__PURE__ */ i("div", { style: vn, "data-testid": "notes-grid", children: b.map((D, B) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: columns are positional, index is stable
      /* @__PURE__ */ i("div", { style: En, children: D.map((E) => {
        var j;
        return /* @__PURE__ */ i(
          Sn,
          {
            noteId: E.id,
            date: E.createdAt,
            type: E.reaction[0] ?? L.IMPORTANT,
            highlight: (j = E.highlightData) == null ? void 0 : j.selectedText,
            note: E.userText,
            isActive: g === E.id,
            isPanelView: !!g,
            onClick: l ? () => l(E.id) : void 0,
            onDelete: d ? (A) => d(A) : void 0,
            onSaveNote: f ? (A, x) => f(A, x) : void 0,
            onTypeChange: c ? (A, x) => c(A, x) : void 0,
            highlightTheme: S,
            cardTheme: C,
            locale: I,
            renderLink: O,
            href: R ? R(E.id, E) : void 0
          },
          E.id
        );
      }) }, B)
    )) }),
    k && /* @__PURE__ */ N(v, { justifyItems: "center", gap: "small", padding: "small", "data-testid": "notes-pagination", children: [
      /* @__PURE__ */ i(
        G,
        {
          size: "small",
          screenReaderLabel: w.previousPage,
          "data-testid": "notes-prev-page",
          interaction: o != null && o.hasPreviousPage ? "enabled" : "disabled",
          onClick: r,
          children: /* @__PURE__ */ i(Je, {})
        }
      ),
      /* @__PURE__ */ i(
        G,
        {
          size: "small",
          screenReaderLabel: w.nextPage,
          "data-testid": "notes-next-page",
          interaction: o != null && o.hasNextPage ? "enabled" : "disabled",
          onClick: s,
          children: /* @__PURE__ */ i(et, {})
        }
      )
    ] })
  ] });
}, Kn = ({
  noteText: n,
  reaction: e,
  highlightText: t,
  highlightTheme: o,
  onSave: r,
  onDelete: s,
  onTypeChange: l,
  onBack: d,
  editing: f = !1
}) => {
  const { translations: c } = Q(), [g, m] = H(f), [u, S] = H(n || ""), [C, I] = H(!1);
  return /* @__PURE__ */ N(v, { direction: "column", gap: "small", "data-testid": "single-note", children: [
    t != null ? /* @__PURE__ */ i(K, { as: "div", children: /* @__PURE__ */ i(U, { children: /* @__PURE__ */ i(fe, { type: e, isCardActive: !0, theme: o, children: t }) }) }) : /* @__PURE__ */ i(qe, {}),
    /* @__PURE__ */ i($e, { type: e, onTypeChange: l, renderAsMenuTrigger: !!l }),
    g ? /* @__PURE__ */ N(v, { direction: "column", gap: "x-small", children: [
      /* @__PURE__ */ i(
        Pe,
        {
          label: c.addNoteOptional,
          value: u,
          onChange: (O) => S(O.target.value),
          resize: "vertical"
        }
      ),
      /* @__PURE__ */ N(v, { gap: "xx-small", children: [
        /* @__PURE__ */ i(v.Item, { shouldGrow: !0, children: /* @__PURE__ */ i(
          W,
          {
            display: "block",
            size: "small",
            "data-testid": "single-note-cancel",
            onClick: () => {
              S(n || ""), m(!1);
            },
            children: c.cancel
          }
        ) }),
        /* @__PURE__ */ i(v.Item, { shouldGrow: !0, children: /* @__PURE__ */ i(
          W,
          {
            display: "block",
            color: "primary",
            size: "small",
            "data-testid": "single-note-save",
            onClick: () => {
              r(u), m(!1);
            },
            children: c.save
          }
        ) })
      ] })
    ] }) : /* @__PURE__ */ N(v, { direction: "column", gap: "small", children: [
      n && /* @__PURE__ */ N(K, { as: "div", children: [
        /* @__PURE__ */ i(ie, { level: "h4", margin: "0 0 xx-small 0", children: c.note }),
        /* @__PURE__ */ i(U, { children: n })
      ] }),
      /* @__PURE__ */ N(v, { justifyItems: "space-between", children: [
        /* @__PURE__ */ i(
          W,
          {
            size: "small",
            renderIcon: /* @__PURE__ */ i(tt, {}),
            "data-testid": "single-note-back",
            onClick: () => d == null ? void 0 : d(),
            children: c.back
          }
        ),
        /* @__PURE__ */ N(v, { gap: "xx-small", children: [
          s && /* @__PURE__ */ i(
            G,
            {
              size: "small",
              withBackground: !1,
              withBorder: !1,
              color: "danger",
              screenReaderLabel: c.deleteNote,
              "data-testid": "single-note-delete",
              onClick: () => I(!0),
              children: /* @__PURE__ */ i(se, {})
            }
          ),
          /* @__PURE__ */ i(
            G,
            {
              size: "small",
              withBackground: !1,
              withBorder: !1,
              screenReaderLabel: c.editNote,
              "data-testid": "single-note-edit",
              onClick: () => m(!0),
              children: /* @__PURE__ */ i(de, {})
            }
          )
        ] })
      ] }),
      C && s && /* @__PURE__ */ i(K, { as: "div", background: "primary", padding: "medium", borderRadius: "large", children: /* @__PURE__ */ N(v, { direction: "column", justifyItems: "center", alignItems: "center", gap: "x-small", children: [
        /* @__PURE__ */ i(
          W,
          {
            display: "block",
            color: "danger",
            size: "small",
            renderIcon: /* @__PURE__ */ i(se, {}),
            "data-testid": "single-note-confirm-delete",
            onClick: () => {
              s(), I(!1);
            },
            children: c.deleteNote
          }
        ),
        /* @__PURE__ */ i(
          W,
          {
            display: "block",
            size: "small",
            "data-testid": "single-note-cancel-delete",
            onClick: () => I(!1),
            children: c.cancel
          }
        )
      ] }) })
    ] })
  ] });
};
export {
  qn as ContentWithNoteWrapper,
  fe as Highlight,
  qe as HighlightError,
  Sn as NoteCard,
  $e as NoteChip,
  Nn as NoteReactionMenu,
  Wn as NotebookProvider,
  gn as NotebookTranslationsProvider,
  $n as NotebookTray,
  Gn as NotesListView,
  L as REACTION_TYPE,
  Kn as SingleNote,
  ae as createTransparentColor,
  kt as useCreateNote,
  Ot as useDeleteNote,
  Rt as useGetNotes,
  We as useNotebook,
  Q as useNotebookTranslations,
  Dt as useUpdateNote
};
